/* Woodn Grail - Shop By School map. Namespaced wgmap- to stay clear of the
   mobile menu drawer, which already uses .wgm and .wgm-head. */
function wgmapInit(root){
  if(!root||root.dataset.wgmapInit)return; root.dataset.wgmapInit="1";

  var FULL={lon0:-125.5,lon1:-66.0,lat0:49.8,lat1:24.0};
  var US=[[-124.7,48.4],[-124.0,46.3],[-124.4,43.0],[-124.2,41.0],[-123.8,39.0],[-122.5,37.8],[-121.0,36.0],[-120.6,34.6],[-118.5,34.0],[-117.1,32.5],[-114.7,32.7],[-111.0,31.3],[-108.2,31.3],[-108.2,31.8],[-106.5,31.8],[-104.9,29.3],[-103.1,29.0],[-102.3,29.9],[-101.4,29.8],[-100.0,28.1],[-99.1,26.4],[-97.4,25.9],[-97.2,27.9],[-96.4,28.7],[-94.8,29.3],[-93.8,29.7],[-92.0,29.6],[-90.2,29.1],[-89.4,30.2],[-88.4,30.3],[-87.5,30.3],[-86.0,30.4],[-84.9,29.8],[-84.0,30.1],[-83.2,29.4],[-82.8,28.2],[-82.6,26.8],[-81.6,25.3],[-80.4,25.2],[-80.1,26.8],[-80.6,28.6],[-81.3,30.4],[-80.9,32.0],[-79.2,33.4],[-77.9,34.2],[-75.8,35.2],[-76.0,36.9],[-75.2,38.0],[-74.0,39.5],[-73.9,40.7],[-72.0,41.3],[-70.7,41.6],[-70.0,42.0],[-70.8,43.1],[-69.0,44.0],[-67.0,44.8],[-67.8,45.7],[-69.0,47.4],[-70.7,45.4],[-71.5,45.0],[-74.7,45.0],[-76.9,44.0],[-79.2,43.4],[-79.0,42.7],[-82.7,41.7],[-83.1,42.2],[-82.5,43.0],[-82.4,45.2],[-84.1,46.0],[-84.6,46.5],[-86.5,46.6],[-88.0,48.2],[-89.5,48.0],[-92.0,48.6],[-95.2,49.0],[-95.2,49.4],[-123.0,49.0]];
  var LAKE=[[-87.8,45.7],[-85.3,45.7],[-85.5,43.4],[-86.3,42.1],[-87.6,41.8],[-87.9,44.2]];
  function inPoly(px,py,poly){var hit=false;
    for(var i=0,j=poly.length-1;i<poly.length;j=i++){
      var xi=poly[i][0],yi=poly[i][1],xj=poly[j][0],yj=poly[j][1];
      if(((yi>py)!==(yj>py))&&(px<(xj-xi)*(py-yi)/(yj-yi)+xi))hit=!hit;}
    return hit;}

  var mapEl=root.querySelector(".wgmap-map"),
      cv=root.querySelector(".wgmap-canvas"),
      tip=root.querySelector(".wgmap-tip"),
      pop=root.querySelector(".wgmap-pop"),
      mapwrap=root.querySelector(".wgmap-mapwrap"),
      listEl=root.querySelector(".wgmap-list"),
      showall=root.querySelector(".wgmap-showall"),
      chipsEl=root.querySelector(".wgmap-chips"),
      chipBar=root.querySelector(".wgmap-chipbar"),
      pins=[].slice.call(root.querySelectorAll(".wgmap-pin")),
      rows=[].slice.call(root.querySelectorAll(".wgmap-row")),
      groups=[].slice.call(root.querySelectorAll(".wgmap-rgroup")),
      cards={};
  if(!mapEl)return;
  [].forEach.call(root.querySelectorAll(".wgmap-card"),function(c){cards[c.dataset.h]=c;});

  var region="all", active=null, expanded=false;
  var CAP=parseInt(root.dataset.cap,10)||18;
  var SHOWALL_LABEL=root.dataset.showall||"Show all {count} schools";
  var phone=function(){return window.matchMedia("(max-width:760px)").matches;};

  function matches(el){
    return region==="all"||el.dataset.region===region;
  }

  /* The region chips scroll sideways on narrow screens, so South and East sit
     off screen with nothing to say so. This drives a slim indicator bar and the
     right edge fade. */
  function updateChipBar(){
    if(!chipsEl||!chipBar)return;
    var max=chipsEl.scrollWidth-chipsEl.clientWidth;
    var scrollable=max>4;
    chipBar.classList.toggle("is-on",scrollable);
    chipsEl.classList.toggle("is-scrollable",scrollable);
    chipsEl.classList.toggle("at-end",!scrollable||chipsEl.scrollLeft>=max-2);
    if(!scrollable)return;
    var thumb=chipBar.firstElementChild; if(!thumb)return;
    var ratio=chipsEl.clientWidth/chipsEl.scrollWidth;
    thumb.style.width=(ratio*100).toFixed(2)+"%";
    thumb.style.left=((chipsEl.scrollLeft/chipsEl.scrollWidth)*100).toFixed(2)+"%";
  }
  if(chipsEl)chipsEl.addEventListener("scroll",updateChipBar,{passive:true});

  function drawDots(){
    var rect=mapEl.getBoundingClientRect(); if(!rect.width)return;
    var dpr=Math.min(window.devicePixelRatio||1,2);
    cv.width=rect.width*dpr; cv.height=rect.height*dpr;
    var ctx=cv.getContext("2d"); ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.clearRect(0,0,rect.width,rect.height);
    ctx.fillStyle=getComputedStyle(root).getPropertyValue("--wgmap-dot").trim()||"#D6D6D6";
    var pitch=rect.width<560?8.4:14.4;
    var cols=Math.max(24,Math.round(rect.width/pitch)),
        rws=Math.max(14,Math.round(rect.height/pitch));
    var cw=rect.width/cols, ch=rect.height/rws;
    var rad=Math.max(1.2,Math.min(cw,ch)*0.34);
    for(var r=0;r<rws;r++)for(var c=0;c<cols;c++){
      var px=(c+.5)*cw, py=(r+.5)*ch;
      var lon=FULL.lon0+(px/rect.width)*(FULL.lon1-FULL.lon0);
      var lat=FULL.lat0-(py/rect.height)*(FULL.lat0-FULL.lat1);
      if(!inPoly(lon,lat,US))continue;
      if(inPoly(lon,lat,LAKE))continue;
      ctx.beginPath(); ctx.arc(px,py,rad,0,6.284); ctx.fill();
    }
  }

  var nodeMap={};
  function placePins(){
    var rect=mapEl.getBoundingClientRect(); if(!rect.width)return;
    nodeMap={};
    var small=rect.width<560, narrowed=region!=="all";
    var minGap=small?(narrowed?28:19):21;
    var pad=small?13:11;

    /* Hawaii sits outside the lower 48, so it projects off canvas. Park anything
       offshore in the open water below the southwest coast, as a share of the map
       so it holds the same spot at every width, and let it behave like an ordinary
       pin from there. The entry keeps its real lat/long. */
    var offshore=0;

    var nodes=[];
    pins.forEach(function(p){
      var on=matches(p);
      p.classList.toggle("is-hidden",!on);
      if(!on)return;
      var lat=parseFloat(p.dataset.lat), lng=parseFloat(p.dataset.lng);
      if(isNaN(lat)||isNaN(lng)){p.classList.add("is-hidden");return;}
      var x=((lng-FULL.lon0)/(FULL.lon1-FULL.lon0))*rect.width,
          y=((FULL.lat0-lat)/(FULL.lat0-FULL.lat1))*rect.height;
      if(x<0||x>rect.width||y<0||y>rect.height){
        x=rect.width*0.075+offshore*minGap; y=rect.height*0.88; offshore++;
      }
      nodes.push({el:p,x:x,y:y});
    });

    /* Clamping used to run once after the solver finished, which shoved edge
       pins back on top of each other. Clamp every pass instead, so the solver
       spreads them with the boundary already accounted for. */
    function clamp(nd){
      nd.x=Math.max(pad,Math.min(rect.width-pad,nd.x));
      nd.y=Math.max(pad,Math.min(rect.height-pad,nd.y));
    }
    function settle(){
      for(var a=0;a<nodes.length;a++)for(var b=a+1;b<nodes.length;b++){
        var A=nodes[a],B=nodes[b];
        var dx=B.x-A.x,dy=B.y-A.y,d=Math.sqrt(dx*dx+dy*dy);
        if(d>=minGap)continue;
        if(d<0.001){dx=0.7;dy=0.7;d=1;}
        var push=(minGap-d)/2,ux=dx/d,uy=dy/d;
        A.x-=ux*push;A.y-=uy*push;
        B.x+=ux*push;B.y+=uy*push;
      }
      nodes.forEach(clamp);
    }
    for(var it=0;it<200;it++)settle();

    nodes.forEach(function(nd){
      nd.el.style.left=nd.x+"px"; nd.el.style.top=nd.y+"px";
      nd.el.classList.add("is-placed");
      nodeMap[nd.el.dataset.h]=nd;
    });
  }

  function clearPopPosition(){
    pop.style.left=""; pop.style.top="";
    pop.classList.remove("flip");
    pop.style.removeProperty("--wgmap-arrow");
  }

  function closePop(){active=null;pop.classList.remove("on");pop.innerHTML="";
    clearPopPosition();
    pins.forEach(function(p){p.classList.remove("is-active");});}

  function openPop(h){
    var card=cards[h], nd=nodeMap[h]; if(!card||!nd)return;
    active=h;
    pins.forEach(function(p){p.classList.toggle("is-active",p.dataset.h===h);});
    pop.innerHTML=card.innerHTML;
    var cl=pop.querySelector(".wgmap-close");
    if(cl)cl.addEventListener("click",function(e){e.stopPropagation();closePop();});
    pop.classList.add("on");

    /* Desktop positions the popover with inline left/top. An inline value beats
       the phone sheet's left:0/right:0, so a popover opened at desktop width and
       reopened on a phone collapsed to zero width off screen. Always clear the
       inline position before deciding where this one goes. */
    clearPopPosition();
    if(phone())return;

    var wrapW=pop.parentElement.clientWidth;
    var w=pop.offsetWidth, hgt=pop.offsetHeight;
    pop.classList.toggle("flip", nd.y-hgt-26<0);
    var left=Math.max(w/2+6,Math.min(wrapW-w/2-6,nd.x));
    pop.style.left=left+"px"; pop.style.top=nd.y+"px";
    pop.style.setProperty("--wgmap-arrow",Math.max(14,Math.min(w-14,nd.x-(left-w/2)))+"px");
  }

  pins.forEach(function(p){
    p.addEventListener("click",function(e){e.stopPropagation();openPop(p.dataset.h);});
    function show(){var nd=nodeMap[p.dataset.h];if(!nd)return;
      tip.textContent=p.dataset.name;tip.style.left=nd.x+"px";tip.style.top=nd.y+"px";tip.classList.add("on");}
    function hide(){tip.classList.remove("on");}
    p.addEventListener("mouseenter",show); p.addEventListener("mouseleave",hide);
    p.addEventListener("focus",show); p.addEventListener("blur",hide);
  });
  pop.addEventListener("click",function(e){e.stopPropagation();});
  function onDocClick(){if(active)closePop();}
  function onDocKey(e){if(e.key==="Escape"&&active)closePop();}
  document.addEventListener("click",onDocClick);
  document.addEventListener("keydown",onDocKey);

  function renderList(){
    var vis=rows.filter(matches);
    var capped=phone()&&region==="all"&&!expanded&&vis.length>CAP;
    var allow=null;
    /* The list reads A-Z, so truncate in order. Cherry-picking the biggest
       schools would leave holes in the alphabet with nothing explaining them. */
    if(capped){
      allow={};
      vis.slice(0,CAP).forEach(function(el){allow[el.dataset.h]=1;});
    }
    rows.forEach(function(el){
      var on=matches(el)&&(!allow||allow[el.dataset.h]);
      el.classList.toggle("is-hidden",!on);
    });
    groups.forEach(function(g){
      var any=[].slice.call(g.querySelectorAll(".wgmap-row")).some(function(el){return !el.classList.contains("is-hidden");});
      g.classList.toggle("is-hidden",!any);
    });
    showall.hidden=!capped;
    showall.classList.toggle("on",capped);
    if(capped)showall.textContent=SHOWALL_LABEL.replace("{count}",vis.length);
  }

  root.querySelector(".wgmap-chips").addEventListener("click",function(e){
    var b=e.target.closest(".wgmap-chip"); if(!b)return;
    region=b.dataset.region;
    [].forEach.call(this.children,function(c){c.setAttribute("aria-pressed",String(c===b));});
    closePop(); refresh();
  });
  showall.addEventListener("click",function(){expanded=true;renderList();});

  function applyView(v){
    [].forEach.call(root.querySelector(".wgmap-view").children,function(c){
      c.setAttribute("aria-pressed",String(c.dataset.view===v));});
    mapwrap.classList.toggle("is-hidden",v!=="map");
    listEl.classList.toggle("on",v==="list");
  }
  root.querySelector(".wgmap-view").addEventListener("click",function(e){
    var b=e.target.closest("button"); if(!b)return;
    applyView(b.dataset.view);
    closePop();
    renderList();
    /* Lay the map out synchronously. getBoundingClientRect forces the layout we
       need, and requestAnimationFrame is paused in background tabs, which left
       the pins unplaced when the section opened on List. */
    if(b.dataset.view==="map"){placePins();drawDots();}
  });

  function refresh(){placePins();drawDots();renderList();updateChipBar();}

  var rt, ro=null;
  function onResize(){clearTimeout(rt);rt=setTimeout(function(){closePop();refresh();},130);}
  if(window.ResizeObserver){ro=new ResizeObserver(onResize);ro.observe(mapEl);}
  else{window.addEventListener("resize",onResize);}

  /* Web fonts and late images can change the section width after first paint,
     which would leave the pins laid out for the old width. Re-run once things
     have settled, and again when fonts report ready. */
  function settleLater(){placePins();drawDots();updateChipBar();}
  window.addEventListener("load",settleLater);
  if(document.fonts&&document.fonts.ready&&document.fonts.ready.then){
    document.fonts.ready.then(settleLater);
  }
  setTimeout(settleLater,350);

  /* The theme editor swaps in fresh markup on every settings change. Without a
     teardown, document listeners and observers pile up, each pinning a detached
     copy of the section in memory. */
  root.wgmapDestroy=function(){
    document.removeEventListener("click",onDocClick);
    document.removeEventListener("keydown",onDocKey);
    window.removeEventListener("load",settleLater);
    if(ro){ro.disconnect();}else{window.removeEventListener("resize",onResize);}
    clearTimeout(rt);
    root.wgmapDestroy=null;
  };
  WGMAP_LIVE.push(root);

  /* starting view is a theme setting, set separately for phones and desktop */
  var startView = phone()
    ? (root.dataset.defaultMobile || "list")
    : (root.dataset.defaultDesktop || "map");
  applyView(startView === "list" ? "list" : "map");
  root.classList.remove("wgmap-preinit");
  refresh();
}

var WGMAP_LIVE=[];
function wgmapReap(){
  WGMAP_LIVE=WGMAP_LIVE.filter(function(r){
    if(r.isConnected)return true;
    if(r.wgmapDestroy)r.wgmapDestroy();
    return false;
  });
}
function wgmapBoot(scope){
  wgmapReap();
  [].forEach.call((scope||document).querySelectorAll(".wgmap"),wgmapInit);
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",function(){wgmapBoot();});}else{wgmapBoot();}
/* theme editor re-renders a section without a page load */
document.addEventListener("shopify:section:load",function(e){wgmapBoot(e.target);});
document.addEventListener("shopify:section:unload",function(){wgmapReap();});
